<template>
  <vs-popup fullscreen :active.sync="show" :title="`Unidades da Matriz ${cnpj}`">
    <div class="flex flex-col gap-2 pb-4">
      <div class="flex flex-col gap-1">
        <label class="font-bold">Matriz Nome Fantasia</label>
        {{_.get(legal_entity, 'trading_name')}}
      </div>
      <div class="flex flex-col gap-1">
        <label class="font-bold">Matriz Razão Social</label>
        {{_.get(legal_entity, 'company_name')}}
      </div>
    </div>
    <vs-table :data="legal_units" class="h-full">
      <template slot="thead">
        <vs-th sort-key="id">ID</vs-th>
        <vs-th sort-key="trading_name">Nome Fantasia</vs-th>
        <vs-th sort-key="company_name">Razão Social</vs-th>
        <vs-th sort-key="cnpj">CNPJ</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :class="`_data-viewer_${tr.key}`" :key="data[i]" v-for="(tr, i) in data">
          <vs-td>
            {{ tr.id }}
          </vs-td>
          <vs-td>
            {{ tr.trading_name }}
          </vs-td>
          <vs-td>
            {{ tr.company_name }}
          </vs-td>
          <vs-td>
            {{ tr.cnpj_formmated }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vs-popup>
</template>

<script>
export default {

  data: () => ({
    show: false,
    legal_entity: null
  }),

  methods: {
    open(legalEntity) {
      this.legal_entity = legalEntity
      this.show = true
    },
    getLegalEntityDisplay() {
      const model = this.legal_entity
      const name = `${model.company_name} - '${model.trading_name}' (${this.cnpjFormat(model.cnpj)})` 

      return name
    }
  },

  computed: {
    legal_units() {
      return this._.get(this.legal_entity, 'legal_units', [])
    },
    cnpj() {
      return this._.get(this.legal_entity, 'cnpj_formmated', '') || ''
    }
  }
}
</script>

<style>

</style>